import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

import('./style.css');

const PageLoader = ({color = "#71b46a", size=24}) => {
    return <div className="page-loading-wrapper">
        <BeatLoader color={color} size={size} />
    </div>
}

export default PageLoader;